export const financialForensicsConstants = {
  title: 'Fiscal Controls',
  tabs: ['Financials', 'Employee Count', 'Documents'],

  financials: {
    fixedTitle: 'Fixed Costs',
    variableTitle: 'Variable Costs',
  },
  employeeCount: {
    countTitle: 'Employee Count',
    subscriptionTitle: 'Employee Count by Subscription Type',
    planTitle: 'Employee Count by Plan Type',
  },
  contributionTable: {
    fixedCosts: {
      planTitle: 'Plan Contribution',
      planSections: [
        'Fees',
        'Stop Loss',
        'Financial Opportunities - Credits, Allowances and Penalties',
      ],
      memberTitle: 'Member Contribution',
      memberSections: ['Fees'],
      emptyTitle: 'No Vendors added to this category',
      emptyPrimarySubtitle:
        'There are currently no fee lines listed under this category',
      emptySecondarySubtitle:
        'There are currently no financial opportunities listed under this category',
    },
    variableCosts: {
      planTitle: 'Plan Contribution',
      planSections: [
        'Claims',
        'Financial Adjustments - Rebates, Recoveries and Reimbursments',
      ],
      memberTitle: 'Member Contribution',
      memberSections: ['Claims'],
      emptyTitle: 'No claim lines added to this category',
      emptyPrimarySubtitle:
        'There are currently no claim lines listed under this category',
      emptySecondarySubtitle:
        'There are currently no financial adjustments listed under this category',
    },
  },
  employeeCountTable: {
    countTitle: 'Total Count',
    subscriptionTitle: 'Employee Count by Subscription Type',
    planTitle: 'Employee Count by Plan Type',
  },

  addVendor: 'Add New Vendor',
  vendorName: 'Name of Vendor',
  service_type: 'Service Type',
  delete: 'Delete',
  start_date: 'Start Month - Year',
  end_date: 'End Month - Year',
  service_name: 'Name of the Service',
  fee_contribution: 'Fee Contribution',
  payment_mode: 'Mode of Payment',
  applicable: 'Applicable',
  fee_unit: 'Unit of Fees',
  fee_placeholder: 'Enter your fees here',
  add_new_service: 'Add New Service',
  upload: 'Upload Document',
  delete_vendor: 'Delete Vendor',
  Save_update: 'Save & Update',
  submit: 'Submit',
  date_format: 'YYYY-MM-DD',
  policyStartYear: 'Policy Year - Start Month',
  policyEndYear: 'Policy Year - End Month',
  coverage: 'Select Coverage',
  addStoploss: 'Add New Stop-Loss',
  tieredSubscriptions: [
    'Employee',
    'Employee + Spouse',
    'Employee + Child(ren)',
    'Employee + Family',
  ],
  feeCalculation: 'Fee Calculation',
  sourceOfData: 'Source Of Data',
  amountTypeQuestion: 'How do you want to supply the amount ?',
  detailsQuestion: 'How do you want to enter the details ?',
  addClaimLine: 'Add Claim Line',
  addReimbursement: 'Add Rebates, Recoveries & Reimbursements',
  addOtherClaimLine: 'Add Claim Line - Other',
  name: 'Name',
  select: 'Select',
  vendor: 'Vendor',
  type: 'Type',
  notes: 'Notes',
  countQuestion: 'How do you want to enter the count ?',
  planContribution: 'How do you want enter break down for plan contribution?',
  addEmployeeCount: 'Add Employee Count',
  subscriptionType: 'Enter Subscription Type',
  addRow: 'Add Row',
  deleteClaim: 'Delete Claim',

  UNITS: [
    'PEPM (Per Employee Subscribed Per Month)',
    'Per Employee Per Month',
    'PEPY',
    'Per Engaged Member Per Month',
    'Per Engaged Member Per Year',
    'Per Script',
    'Per Eligible Claim',
    'Per Case',
    'Per Event',
    'Per Hour',
    'Per Year',
    'Flat Monthly Fee',
    'One Time',
    '% of Savings',
    '% of Paid Claims',
    '% of Billed Charges',
    '% of Rebate',
    '% of Fees',
    'Basis Points (bps)',
    'Per Diabetic Per Month',
    'PEPM (Per Qualified Employee Per Month)',
    'Per Claim',
    'Per Net Paid Claim',
    'Per Processed Paper Claim',
    'Per Impacted Rx',
    'Per Record',
    'Per ID Card',
    'Postage / Shipping (As Invoiced)',
    'Per Seat Annual',
    'PMPM (Per Member Per Month)',
    '% of Received Rebates',
    'As Invoiced',
  ],

  APPLICABLE_OPTIONS: ['Enrolled Employees', 'All Employees'],
  EMPLOYEE_COUNT_SOURCE_OPTIONS: ['Census', 'Fee Schedule', 'Invoice'],

  ERROR: {
    ADD_VENDOR: 'Failed to add vendor',
    UPDATE_VENDOR: 'Failed to update vendor',
    DELETE_VENDOR: 'Failed to delete vendor',
    UPDATE_FEE_CALCULATION: 'Failed to update fee calculation',
    ADD_REBATES: 'Failed to add Financial Adjustments',
    UPDATE_REBATES: 'Failed to update Financial Adjustments',
    ADD_CLAIMS: 'Failed to add Claim',
    UPDATE_CLAIMS: 'Failed to update Claim',
    DELETE_CLAIMS: 'Failed to delete Claim',
    UPDATE_SOURCE_OF_DATA: 'Error Updating Source of Data',
    FETCH_DATES: 'Error fetching Plan Dates',
    ADD_PLAN_DATES: 'Error adding plan dates',
  },
  SUCCESS: {
    ADD_VENDOR: 'Vendor added successfully',
    UPDATE_VENDOR: 'Vendor updated successfully',
    DELETE_VENDOR: 'Vendor deleted successfully',
    UPDATE_FEE_CALCULATION: 'Fee Calculation updated successfully',
    ADD_REBATES: 'Financial Adjustments added successfully',
    UPDATE_REBATES: 'Financial Adjustments updated successfully',
    ADD_CLAIMS: 'Claims data added successfully',
    UPDATE_CLAIMS: 'Claims data updated successfully',
    DELETE_CLAIMS: 'Claims data deleted successfully',
    ADD_PLAN_DATES: 'Plan Dates added successfully',
  },

  DATE_SELECTION_TITLE: 'Fiscal Control Period Selection',
  DATE_SELECTION_SUBTITLE:
    'Select the date range for which you want to apply or review fiscal controls',
};
